import { render, staticRenderFns } from "./WasteOut.vue?vue&type=template&id=e2e5bdd2&scoped=true"
import script from "./WasteOut.vue?vue&type=script&lang=js"
export * from "./WasteOut.vue?vue&type=script&lang=js"
import style0 from "./WasteOut.vue?vue&type=style&index=0&id=e2e5bdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e5bdd2",
  null
  
)

export default component.exports